module.exports = __webpack_public_path__ + "media/assets/images/votorantim-cimentos-99c534ade5b8f2ad8368561a859a41b5.png";